import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Home from '@/components/home/Home'
import IosMoney from '@/components/ios/IosMoney'
import HomeUserData from '@/components/home/HomeUserData'
import Menu from '@/components/sys/Menu'
import RoleManage from '@/components/sys/RoleManage'
import Manager from '@/components/sys/Manager'
import AppRenewManage from '@/components/sys/AppRenewManage'
import Cooperator from '@/components/user/Cooperator'
import CooperatorProvice from '@/components/user/CooperatorProvice'
import User from '@/components/user/User'
import CooperatorSalesman from '@/components/user/CooperatorSalesman'
import TargetManage from '@/components/user/TargetManage'
import NewsData from '@/components/user/NewsData'
import ApplyManage from '@/components/user/ApplyManage'
import Agreement from '@/components/user/Agreement'
import UserOpinion from '@/components/user/UserOpinion'
import UserBuy from '@/components/user/UserBuy'
import UserInvoice from '@/components/user/UserInvoice'
import Secret from '@/components/platform/Secret'
import AppHelp from '@/components/platform/AppHelp'
import Carousel from '@/components/platform/Carousel'
import ThemeImage from '@/components/platform/ThemeImage'
import DoctorInfo from '@/components/doctor/DoctorInfo'
import DoctorExpert from '@/components/doctorExpert/DoctorExpert'
import DoctorUserApply from '@/components/doctor/UserApply'
import Article from '@/components/article/Article'
import AppHome from '@/components/appHome/AppHome'
import ArticleHot from '@/components/article/ArticleHot'
import ArticleNew from '@/components/article/ArticleNew'
import ArticleFree from '@/components/article/ArticleFree'
import VipManage from '@/components/vip/VipManage'
import Promotion from '@/components/promotion/Promotion'
import AppState from '@/components/appState/AppState'
import Advert from '@/components/advert/Advert'
import UserExpertBuy from '@/components/user/UserExpertBuy'
import ExchangeCode from '@/components/user/ExchangeCode'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/ios/iosMoney',
      name: 'iosMoney',
      component: IosMoney
    },
    {
      path: '/homeUserData',
      name: 'homeUserData',
      component: HomeUserData
    },
    // 菜单管理
    {
      path: '/sys/menu',
      name: 'menu',
      component: Menu
    },
    {
      path: '/sys/roleManage',
      name: 'roleManage',
      component: RoleManage
    },
    {
      path: '/sys/Manager',
      name: 'manager',
      component: Manager
    },
    {
      path: '/sys/appRenewManage',
      name: 'appRenewManage',
      component: AppRenewManage
    },
    {
      path: '/user/cooperator',
      name: 'cooperator',
      component: Cooperator
    },
    {
      path: '/user/cooperatorSalesman',
      name: 'cooperatorSalesman',
      component: CooperatorSalesman
    },
    {
      path: '/user/cooperatorProvice',
      name: 'cooperatorProvice',
      component: CooperatorProvice
    },
    {
      path: '/doctor/doctorInfo',
      name: 'doctorInfo',
      component: DoctorInfo
    },
    {
      path: '/doctorExpert/doctorExpert',
      name: 'doctorExpert',
      component: DoctorExpert
    },
    {
      path: '/doctor/userApply',
      name: 'doctorUserApply',
      component: DoctorUserApply
    },
    {
      path: '/user/user',
      name: 'user',
      component: User
    },
    {
      path: '/user/TargetManage',
      name: 'targetManage',
      component: TargetManage
    },
    {
      path: '/user/NewsData',
      name: 'newsData',
      component: NewsData
    },
    {
      path: '/user/ApplyManage',
      name: 'applyManage',
      component: ApplyManage
    },
    {
      path: '/user/agreement',
      name: 'agreement',
      component: Agreement
    },
    {
      path: '/user/userOpinion',
      name: 'userOpinion',
      component: UserOpinion
    },
    {
      path: '/user/userBuy',
      name: 'userBuy',
      component: UserBuy
    },
    {
      path: '/user/userInvoice',
      name: 'userInvoice',
      component: UserInvoice
    },
    {
      path: '/platform/Secret',
      name: 'secret',
      component: Secret
    },
    {
      path: '/platform/appHelp',
      name: 'appHelp',
      component: AppHelp
    },
    {
      path: '/platform/Carousel',
      name: 'carousel',
      component: Carousel
    },
    {
      path: '/platform/themeImage',
      name: 'themeImage',
      component: ThemeImage
    },
    {
      path: '/article/articleFree',
      name: 'ArticleFree',
      component: ArticleFree
    },
    // 报告---------------
    {
      path: '/article/article',
      name: 'article',
      component: Article
    },
    {
      path: '/appHome/AppHome',
      name: 'appHome',
      component: AppHome
    },
    {
      path: '/article/articleHot',
      name: 'articleHot',
      component: ArticleHot
    },
    {
      path: '/article/articleNew',
      name: 'articleNew',
      component: ArticleNew
    },
    {
      path: '/vip/vipManage',
      name: 'vipManage',
      component: VipManage
    },
    {
      path: '/promotion/promotion',
      name: 'promotion',
      component: Promotion
    },
    {
      path: '/appState/appState',
      name: 'appState',
      component: AppState
    },
    {
      path: '/advert/advert',
      name: 'advert',
      component: Advert
    },
    {
      path: '/user/UserExpertBuy',
      name: 'userExpertBuy',
      component: UserExpertBuy
    },
    {
      path: '/user/exchangeCode',
      name: 'exchangeCode',
      component: ExchangeCode
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js